import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import * as React from 'react';
import { MeasuredTitleContainer } from '../components';

const controlersTitle = (
  <Trans>
    Cabinets de contrôle
  </Trans>
);

export const ControlersSection = (props: {
  widthLines?: ouiStyle.InStyleWithMediaQueries['widthLines'],
  index: number,
  titleBarHeight: number,
  setTitleBarHeight: any,
}) => {
  const {
    titleBarHeight,
    setTitleBarHeight,
    widthLines,
    index,
  } = props;
  return (
    <ouiDom.HeadingSection.HeadingSection
      index={index}
      name="Controlers"
      widthLines={widthLines}
      paddingHorizontal="simple"
    >
      <TopModel
        name="HeadingSectionTitleContainer-3"
        color={ouiStyle.Constants.Colors.accent}
        height={titleBarHeight}
        setHeight={setTitleBarHeight}
      >
        {MeasuredTitleContainer}
      </TopModel>
      <TopModel name="HeadingSectionTitleContent-Controlers">
        {controlersTitle}
      </TopModel>
      <ouiDom.P.P
        color={ouiStyle.Constants.Colors.primary}
      >
        <Trans>
          <ouiDom.TextSnippet.TextSnippet
            color={ouiStyle.Constants.Colors.primary}
            fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          >
            Commissaire – Réviseur agréé :&#32;
          </ouiDom.TextSnippet.TextSnippet>
          Mazars, Bellevue 5-B 1001, 9050 Gent
        </Trans>
      </ouiDom.P.P>
      <ouiDom.P.P
        color={ouiStyle.Constants.Colors.primary}
      >
        <Trans>
          <ouiDom.TextSnippet.TextSnippet
            color={ouiStyle.Constants.Colors.primary}
            fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          >
            Auditeur interne :&#32;
          </ouiDom.TextSnippet.TextSnippet>
          DSD Associates, Kapellekensweg 57, 3391 Tielt-Winge
        </Trans>
      </ouiDom.P.P>
    </ouiDom.HeadingSection.HeadingSection>
  );
};
